exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../../node_modules/css-loader/index.js?modules!./forms.css"), undefined);

// module
exports.push([module.id, "._1f1PDXDizaEj6iw3wMYkMn{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:10px}._19bARfbDjzTBONgV1UPjYm{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;margin:0 10px}.RLPdAxAP57F3qDv1N0KNy{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"root": "_1f1PDXDizaEj6iw3wMYkMn",
	"textField": "_19bARfbDjzTBONgV1UPjYm",
	"title": "RLPdAxAP57F3qDv1N0KNy " + require("-!./../../node_modules/css-loader/index.js?modules!./forms.css").locals["title"] + ""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/postcss-loader!./components/forms/address.css
 ** module id = 1015
 ** module chunks = 0
 **/